/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sales_Range_ToInputs */

const en_cargos_sales_range_to = /** @type {(inputs: Cargos_Sales_Range_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

const es_cargos_sales_range_to = /** @type {(inputs: Cargos_Sales_Range_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Cargos_Sales_Range_ToInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_to = /** @type {((inputs?: Cargos_Sales_Range_ToInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_ToInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_to(inputs)
	return es_cargos_sales_range_to(inputs)
});